import { render, staticRenderFns } from "./whitelistAdd.vue?vue&type=template&id=2beb6de0&scoped=true"
import script from "./whitelistAdd.vue?vue&type=script&lang=js"
export * from "./whitelistAdd.vue?vue&type=script&lang=js"
import style0 from "./whitelistAdd.vue?vue&type=style&index=0&id=2beb6de0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2beb6de0",
  null
  
)

export default component.exports